export enum ClientSidebar {
  POPULATIONS = <any>0,
  ALL_TAXPAYERS = <any>1,
  UPLOAD_SOURCE = <any>2,
}
